import React, { useState } from 'react';
import { CheckCircle, X } from 'lucide-react';

export default function ReactivateLearnerModal({ learner, onClose, onConfirm }) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } catch (error) {
      console.error('Error reactivating learner:', error);
    } finally {
      setLoading(false);
    }
  };

  const name = `${learner.firstName || ''} ${learner.lastName || ''}`.trim();

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">

        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <h2 className="text-xl font-bold text-gray-900">Reactivate Learner</h2>
          <button type="button" onClick={onClose}
            className="p-1 text-gray-400 hover:text-gray-600 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-6 h-6 text-green-600" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">Reactivate this learner?</h3>
              <p className="text-sm text-gray-600 mt-1">
                {name} will regain access to all content and can participate in assessments again.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4 mb-6 space-y-2 text-sm">
            <p><span className="text-gray-600">Name:</span>{' '}
              <span className="font-medium text-gray-900">{name}</span></p>
            <p><span className="text-gray-600">Email:</span>{' '}
              <span className="font-medium text-gray-900">{learner.email}</span></p>
            <p><span className="text-gray-600">Department:</span>{' '}
              <span className="font-medium text-gray-900">{learner.departmentName || '—'}</span></p>
          </div>

          <div className="flex gap-3 justify-end">
            <button type="button" onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors">
              Cancel
            </button>
            <button type="button" onClick={handleConfirm} disabled={loading}
              className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
              {loading ? 'Reactivating…' : 'Reactivate'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}